import {useState} from "react";
import NotificationService from "../services/api/notifications";

const useNotification = () => {

    const [notificationList, setNotificationList] = useState([]);
    const [isFetchingNotifications, setFetchingNotifications] = useState(false);

    const getNotificationList = (parameters) => {
        setFetchingNotifications(true);

        NotificationService.getNotificationList(parameters).then((res) => {
            console.log("getNotificationList data xxxx", res, res.data.data.content);

            if (res.data.success) {
                setNotificationList(res.data.data.content);
                setFetchingNotifications(false);
            }

        }).catch((error) => {
            console.log("getNotificationList error xxxx", error);

            setNotificationList([]);
            setFetchingNotifications(false);
        })
    }

    return {
        notificationList, isFetchingNotifications, getNotificationList,
    }
}

export default useNotification